import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

/** How long a react-query cache entry is considered fresh before refetching. */
const QUERY_STALE_TIME_MS = 60_000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_STALE_TIME_MS,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
const appTree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

/**
 * If react-snap pre-rendered the page at build time, the #root element will
 * already contain server-rendered markup. In that case we hydrate to attach
 * event handlers without re-mounting and re-flowing the DOM. Otherwise we
 * create a fresh root as normal.
 */
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, appTree);
} else {
  ReactDOM.createRoot(rootEl).render(appTree);
}
